import { render, staticRenderFns } from "./safety_Set.vue?vue&type=template&id=0521b2c2&scoped=true"
import script from "./safety_Set.vue?vue&type=script&lang=js"
export * from "./safety_Set.vue?vue&type=script&lang=js"
import style0 from "./safety_Set.vue?vue&type=style&index=0&id=0521b2c2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0521b2c2",
  null
  
)

export default component.exports